import React from "react";
import CustomInput from "../../../components/CustomForm/CustomInput";
import {
  FormWrapper,
  Form,
  FormGroup,
} from "../../../components/CustomForm/FormStyles";
import useEmpresa from "../../../hooks/useEmpresa";
import { Avatar } from "../../../components/Common/CommonStyles";
import Colors from "../../../themes/Colors";

const DetalleAfiliado = ({ numeroAfiliado, cedula, nss, nombres, apellidos, edad, foto }) => {
  const empresa = useEmpresa();

  return (
    <FormWrapper
      flexDirection={"row"}
      flex={"1"}
      borderColor={empresa?.COLOR_PRINCIPAL}
    >
      <FormWrapper borderColor={Colors.transparent} maxWidth={"100px"}>
        <Avatar src={foto} />
      </FormWrapper>

      <FormWrapper borderColor={Colors.transparent}>
        <Form>
          <FormGroup>
            <CustomInput
              type={"text"}
              placeholder={"Número de " + empresa?.TIPO_CLIENTE}
              label={"Número de " + empresa?.TIPO_CLIENTE}
              value={numeroAfiliado}
              disabled={true}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type={"text"}
              placeholder={"Cédula"}
              label={"Cédula"}
              value={cedula}
              disabled={true}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type={"text"}
              placeholder={"NSS"}
              label={"NSS"}
              value={nss}
              disabled={true}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type={"text"}
              placeholder={"Nombres"}
              label={"Nombres"}
              value={nombres}
              disabled={true}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type={"text"}
              placeholder={"Apellidos"}
              label={"Apellidos"}
              value={apellidos}
              disabled={true}
            />
          </FormGroup>
          <FormGroup>
            <CustomInput
              type={"text"}
              placeholder={"Edad"}
              label={"Edad"}
              value={edad}
              disabled={true}
            />
          </FormGroup>
        </Form>
      </FormWrapper>
    </FormWrapper>
  );
};

export default DetalleAfiliado;